module.exports = __webpack_public_path__ + "static/media/Sakura-Regular.e8ece641.otf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola/zola-ui/build/assets/fonts/Sakura-Regular.otf
// module id = 1182
// module chunks = 49